<template>
  <div>
    <b-card no-body class="mb-1">
      <b-card-header
        header-tag="header"
        :class="{ active: activeCollapse == 'publishing' + idx }"
        role="tab"
      >
        <b-button
          class="btn-collapse"
          block
          variant="collapse"
          v-b-toggle="'publishing' + idx"
        >
          <span
            class="status-btn"
            :style="{ background: getStatusColor(publishing.status) }"
          >
            {{ getStatus(publishing.status) }}
          </span>
          {{ publishing.title }}
        </b-button>

        <span
          class="edit"
          @click="handleEditPublishing(idx)"
          v-b-popover.top.hover="`Edit ${publishing.title}`"
          ><svg
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M2.6665 3.33333C2.48969 3.33333 2.32012 3.40357 2.1951 3.5286C2.07008 3.65362 1.99984 3.82319 1.99984 4V13.3333C1.99984 13.5101 2.07007 13.6797 2.1951 13.8047C2.32012 13.9298 2.48969 14 2.6665 14H11.9998C12.1766 14 12.3462 13.9298 12.4712 13.8047C12.5963 13.6797 12.6665 13.5101 12.6665 13.3333V9.77333C12.6665 9.40514 12.965 9.10667 13.3332 9.10667C13.7014 9.10667 13.9998 9.40514 13.9998 9.77333V13.3333C13.9998 13.8638 13.7891 14.3725 13.4141 14.7475C13.039 15.1226 12.5303 15.3333 11.9998 15.3333H2.6665C2.13607 15.3333 1.62736 15.1226 1.25229 14.7475C0.877218 14.3725 0.666504 13.8638 0.666504 13.3333V4C0.666504 3.46957 0.877217 2.96086 1.25229 2.58579C1.62736 2.21071 2.13607 2 2.6665 2H6.2265C6.59469 2 6.89317 2.29848 6.89317 2.66667C6.89317 3.03486 6.59469 3.33333 6.2265 3.33333H2.6665Z"
              fill="#B3C2CB"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M11.5284 0.86201C11.7888 0.601661 12.2109 0.601661 12.4712 0.86201L15.1379 3.52868C15.3983 3.78903 15.3983 4.21114 15.1379 4.47149L8.47124 11.1382C8.34622 11.2632 8.17665 11.3334 7.99984 11.3334H5.33317C4.96498 11.3334 4.6665 11.0349 4.6665 10.6667V8.00008C4.6665 7.82327 4.73674 7.6537 4.86177 7.52868L11.5284 0.86201ZM5.99984 8.27622V10.0001H7.7237L13.7237 4.00008L11.9998 2.27622L5.99984 8.27622Z"
              fill="#B3C2CB"
            />
          </svg>
        </span>
        <span
          class="delete"
          @click="handleDeletePublishing()"
          v-b-popover.top.hover="`Delete ${publishing.title}`"
        >
          <svg
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M1.3335 4.00008C1.3335 3.63189 1.63197 3.33341 2.00016 3.33341H14.0002C14.3684 3.33341 14.6668 3.63189 14.6668 4.00008C14.6668 4.36827 14.3684 4.66675 14.0002 4.66675H2.00016C1.63197 4.66675 1.3335 4.36827 1.3335 4.00008Z"
              fill="#EF5C4A"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M6.66683 2.00008C6.49002 2.00008 6.32045 2.07032 6.19543 2.19534C6.0704 2.32037 6.00016 2.48994 6.00016 2.66675V3.33341H10.0002V2.66675C10.0002 2.48994 9.92992 2.32037 9.8049 2.19534C9.67988 2.07032 9.51031 2.00008 9.3335 2.00008H6.66683ZM11.3335 3.33341V2.66675C11.3335 2.13631 11.1228 1.62761 10.7477 1.25253C10.3726 0.877462 9.86393 0.666748 9.3335 0.666748H6.66683C6.1364 0.666748 5.62769 0.877462 5.25262 1.25253C4.87754 1.62761 4.66683 2.13631 4.66683 2.66675V3.33341H3.3335C2.96531 3.33341 2.66683 3.63189 2.66683 4.00008V13.3334C2.66683 13.8638 2.87754 14.3726 3.25262 14.7476C3.62769 15.1227 4.1364 15.3334 4.66683 15.3334H11.3335C11.8639 15.3334 12.3726 15.1227 12.7477 14.7476C13.1228 14.3726 13.3335 13.8638 13.3335 13.3334V4.00008C13.3335 3.63189 13.035 3.33341 12.6668 3.33341H11.3335ZM4.00016 4.66675V13.3334C4.00016 13.5102 4.0704 13.6798 4.19543 13.8048C4.32045 13.9298 4.49002 14.0001 4.66683 14.0001H11.3335C11.5103 14.0001 11.6799 13.9298 11.8049 13.8048C11.9299 13.6798 12.0002 13.5102 12.0002 13.3334V4.66675H4.00016Z"
              fill="#EF5C4A"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M6.66683 6.66675C7.03502 6.66675 7.3335 6.96522 7.3335 7.33341V11.3334C7.3335 11.7016 7.03502 12.0001 6.66683 12.0001C6.29864 12.0001 6.00016 11.7016 6.00016 11.3334V7.33341C6.00016 6.96522 6.29864 6.66675 6.66683 6.66675Z"
              fill="#EF5C4A"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M9.3335 6.66675C9.70169 6.66675 10.0002 6.96522 10.0002 7.33341V11.3334C10.0002 11.7016 9.70169 12.0001 9.3335 12.0001C8.96531 12.0001 8.66683 11.7016 8.66683 11.3334V7.33341C8.66683 6.96522 8.96531 6.66675 9.3335 6.66675Z"
              fill="#EF5C4A"
            />
          </svg>
        </span>
        <span class="chevron" v-b-toggle="`publishing${idx}`">
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M16.293 9.29297L12 13.586L7.70697 9.29297L6.29297 10.707L12 16.414L17.707 10.707L16.293 9.29297Z"
              fill="#B3C2CB"
            />
          </svg>
        </span>
      </b-card-header>
      <b-collapse
        :id="'publishing' + idx"
        accordion="my-accordion"
        role="tabpanel"
      >
        <b-card-body>
          <div class="row">
            <div class="col-2 ml-2">
              <b-img
                  v-if="publishing.imgURL"
                  v-bind="mainProps"
                  :src="publishing.imgURL"
                  rounded alt="Rounded image"
                  :alt="`${publishing.title} app`"
              />
              <image-upload
                v-else
                ref="image-upload"
                :img-upload-idx="idx"
                img-upload-type="publishing"
                :storage-path="storagePath"
                :max-image="1"
                :show-edit="true"
                :show-delete="true"
                style="height:200px;width:200px"
                @img-uploaded-url="handleImgUploadedURL"
              />
            </div>
            <div class="col-9 publishing-description">
              <b-card-text>
                <tip-tap-output
                  v-if="publishing.description"
                  :content="publishing.description"
                  :show-less-char="200"
                  :use-dots="true"
                />
              </b-card-text>
            </div>
          </div>

          <!-- <div class="time">
            <svg
              width="16"
              height="17"
              viewBox="0 0 16 17"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M7.99984 2.50008C4.68613 2.50008 1.99984 5.18637 1.99984 8.50008C1.99984 11.8138 4.68613 14.5001 7.99984 14.5001C11.3135 14.5001 13.9998 11.8138 13.9998 8.50008C13.9998 5.18637 11.3135 2.50008 7.99984 2.50008ZM0.666504 8.50008C0.666504 4.44999 3.94975 1.16675 7.99984 1.16675C12.0499 1.16675 15.3332 4.44999 15.3332 8.50008C15.3332 12.5502 12.0499 15.8334 7.99984 15.8334C3.94975 15.8334 0.666504 12.5502 0.666504 8.50008Z"
                fill="var(--theme-color)"
              />
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M7.99984 3.83341C8.36803 3.83341 8.6665 4.13189 8.6665 4.50008V8.08806L10.9646 9.23713C11.294 9.40179 11.4274 9.80224 11.2628 10.1316C11.0981 10.4609 10.6977 10.5944 10.3684 10.4297L7.70169 9.09637C7.47584 8.98344 7.33317 8.7526 7.33317 8.50008V4.50008C7.33317 4.13189 7.63165 3.83341 7.99984 3.83341Z"
                fill="var(--theme-color)"
              />
            </svg>
            <span>{{ publishing.duration }} mins read</span>
          </div> -->

          <div class="publishing-foot">
            <div
              v-if="publishing.status == 'active' && activePublishing"
              class="stats"
            >
              <span class="ico">
                <svg
                  width="26"
                  height="16"
                  viewBox="0 0 26 16"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M5.90922 2.36355L3.54559 1.27264L1.36377 8.54536L3.54559 9.45445L3.85659 8.54536M5.90922 2.36355L3.85659 8.54536M5.90922 2.36355C6.39407 2.54537 7.69104 3.09082 9.00013 3.09082C10.3092 3.09082 11.9698 3.09082 12.6365 3.09082M3.85659 8.54536L5.18195 9.09082M5.18195 9.09082C5.36377 8.84839 5.87286 8.43627 6.45468 8.72718C7.0365 9.01809 7.06074 9.21203 7.00013 9.27264M5.18195 9.09082L4.81832 10.909C5.0155 11.1062 5.26743 11.3564 5.55146 11.6363M7.00013 9.27264C7.30316 9.15142 7.98195 8.98173 8.27286 9.27264C8.56377 9.56355 8.6365 10.1211 8.6365 10.3635M7.00013 9.27264L5.55146 11.6363M8.6365 10.3635C8.81832 10.3029 9.25468 10.2545 9.54559 10.5454C9.8365 10.8363 9.90922 11.3938 9.90922 11.6363M8.6365 10.3635L6.66909 12.7272M9.90922 11.6363C9.96983 11.6363 10.1638 11.709 10.4547 11.9999C10.7456 12.2908 10.8183 12.606 10.8183 12.7272C10.8183 12.9065 10.7586 13.2783 10.5508 13.6363M9.90922 11.6363L7.90922 13.9067M5.55146 11.6363C5.89101 11.9708 6.27644 12.3478 6.66909 12.7272M6.66909 12.7272C7.09005 13.1339 7.51932 13.5435 7.90922 13.9067M7.90922 13.9067C8.25401 14.2278 8.56803 14.5126 8.81832 14.7272C9.00013 14.909 9.72741 14.5454 10.2729 13.9999C10.3864 13.8864 10.4778 13.7622 10.5508 13.6363M18.4547 9.45445L12.4547 5.63627C11.6062 5.8787 9.80013 6.36355 9.36377 6.36355C8.81832 6.36355 8.45468 5.63627 8.45468 4.909C9.42438 4.30294 11.6183 3.09082 12.6365 3.09082M18.4547 9.45445C18.8183 9.45445 19.691 9.309 20.2729 8.72718C20.8547 8.14536 21.1594 7.63627 21.2391 7.45445M18.4547 9.45445C18.5759 9.9393 18.7456 10.9817 18.4547 11.2726C18.1638 11.5635 17.485 11.6363 17.182 11.6363M21.2391 7.45445L22.091 8.54536L24.4547 6.54536L20.2729 1.09082L17.7274 2.72718L17.9975 3.09082M21.2391 7.45445L17.9975 3.09082M17.9975 3.09082C17.5439 3.45446 16.4547 4.14536 15.7274 3.99991C14.8183 3.81809 13.9092 3.09082 12.6365 3.09082M17.182 11.6363C17.2426 11.9393 17.291 12.6181 17.0001 12.909C16.7092 13.1999 16.0304 13.1514 15.7274 13.0908M17.182 11.6363L13.182 8.54536M15.7274 13.0908C15.8486 13.3332 15.982 13.9272 15.5456 14.3635C15.1092 14.7999 14.1516 14.3029 13.7274 13.9999M15.7274 13.0908L12.2729 10.3635M13.7274 13.9999C13.788 14.1817 13.8001 14.6181 13.3638 14.909C12.6365 15.3938 11.3067 14.1817 10.5508 13.6363M13.7274 13.9999L11.5456 12.1817"
                    stroke="#8D99A0"
                  />
                </svg>
                {{
                  activePublishing.feedback &&
                    activePublishing.feedback.thankyous &&
                    activePublishing.feedback.thankyous.length
                }}
              </span>
              <span class="ico">
                <svg
                  width="19"
                  height="19"
                  viewBox="0 0 19 19"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M1 17.586L4.586 14H16C16.5304 14 17.0391 13.7893 17.4142 13.4142C17.7893 13.0391 18 12.5304 18 12V3C18 2.46957 17.7893 1.96086 17.4142 1.58579C17.0391 1.21071 16.5304 1 16 1H3C2.46957 1 1.96086 1.21071 1.58579 1.58579C1.21071 1.96086 1 2.46957 1 3V17.586ZM1 19H0V3C0 2.20435 0.316071 1.44129 0.87868 0.87868C1.44129 0.316071 2.20435 0 3 0H16C16.7956 0 17.5587 0.316071 18.1213 0.87868C18.6839 1.44129 19 2.20435 19 3V12C19 12.7957 18.6839 13.5587 18.1213 14.1213C17.5587 14.6839 16.7956 15 16 15H5L1 19Z"
                    fill="#8D99A0"
                  />
                </svg>
                {{
                  activePublishing.feedback &&
                    activePublishing.feedback.feedback.length
                }}
              </span>
              <span class="ico">
                <svg
                  width="14"
                  height="18"
                  viewBox="0 0 14 18"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M3 0H11C11.7957 0 12.5587 0.316071 13.1213 0.87868C13.6839 1.44129 14 2.20435 14 3V18L7 15L0 18V3C0 2.20435 0.316071 1.44129 0.87868 0.87868C1.44129 0.316071 2.20435 0 3 0ZM3 1C2.46957 1 1.96086 1.21071 1.58579 1.58579C1.21071 1.96086 1 2.46957 1 3V16.49L7 13.942L13 16.489V3C13 2.46957 12.7893 1.96086 12.4142 1.58579C12.0391 1.21071 11.5304 1 11 1H3Z"
                    fill="#8D99A0"
                  />
                </svg>
                {{
                  activePublishing.feedback &&
                    activePublishing.feedback.bookmarks.length
                }}
              </span>
              <span class="ico">
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M22.4131 11.6862C20.1665 7.53286 16.2265 5.01953 11.8665 5.01953C7.50648 5.01953 3.55982 7.53286 1.33315 11.6862L1.14648 11.9995L1.31982 12.3195C3.56648 16.4729 7.50648 18.9862 11.8665 18.9862C16.2265 18.9862 20.1731 16.5062 22.4131 12.3195L22.5865 11.9995L22.4131 11.6862ZM11.8665 17.6195C8.11315 17.6195 4.66648 15.5262 2.66648 11.9995C4.66648 8.47286 8.11315 6.37953 11.8665 6.37953C15.6198 6.37953 19.0265 8.47953 21.0598 11.9995C19.0265 15.5262 15.6131 17.6195 11.8665 17.6195Z"
                    fill="#8D99A0"
                  />
                  <path
                    d="M12.06 7.44641C11.1561 7.45301 10.2744 7.72733 9.52626 8.23473C8.77815 8.74213 8.19719 9.45985 7.85676 10.2972C7.51632 11.1346 7.43167 12.0541 7.61351 12.9396C7.79534 13.8251 8.23551 14.6368 8.8784 15.2722C9.5213 15.9077 10.3381 16.3384 11.2256 16.5099C12.1131 16.6814 13.0316 16.586 13.865 16.2359C14.6983 15.8857 15.4092 15.2964 15.9079 14.5425C16.4065 13.7885 16.6706 12.9037 16.6666 11.9997C16.664 11.398 16.5427 10.8028 16.3096 10.248C16.0765 9.69329 15.7363 9.19001 15.3083 8.76701C14.8804 8.34402 14.3731 8.00964 13.8157 7.78302C13.2583 7.55641 12.6617 7.44202 12.06 7.44641ZM12.06 15.2597C11.4215 15.2532 10.7992 15.0581 10.2712 14.699C9.74321 14.3398 9.33311 13.8327 9.09241 13.2413C8.8517 12.6499 8.79111 12.0005 8.91825 11.3748C9.0454 10.749 9.3546 10.1748 9.80703 9.72422C10.2595 9.27363 10.8349 8.96678 11.4612 8.84219C12.0875 8.7176 12.7366 8.78084 13.327 9.02396C13.9174 9.26708 14.4229 9.67924 14.7798 10.2087C15.1368 10.7381 15.3293 11.3612 15.3333 11.9997C15.3351 12.4295 15.2515 12.8553 15.0875 13.2525C14.9235 13.6497 14.6822 14.0104 14.3777 14.3136C14.0732 14.6169 13.7116 14.8566 13.3137 15.0191C12.9158 15.1815 12.4897 15.2633 12.06 15.2597Z"
                    fill="#8D99A0"
                  />
                </svg>
                {{
                  activePublishing.feedback &&
                    activePublishing.feedback.views.length
                }}
              </span>
            </div>
            <span v-else></span>
            <div class="collapse-foot">
              <div
                class="upload-btn"
                @click="handleFeatureClick('development')"
              >
                Development
              </div>
              <div class="upload-btn" @click="handleFeatureClick('data')">
                DataBase
              </div>
              <div class="upload-btn" @click="handleFeatureClick('corner')">
                Testing
              </div>
              <div class="upload-btn" @click="handleFeatureClick('corner')">
                Settings
              </div>
              <div class="upload-btn" @click="handleFeatureClick('corner')">
                Tutorial
              </div>
              <div class="upload-btn" @click="handleFeatureClick('corner')">
                Credits
              </div>
              <div class="upload-btn" @click="handleFeatureClick('corner')">
                Page
              </div>
              <div class="upload-btn" @click="handleFeatureClick('qr')">
                QR
              </div>
              <div class="upload-btn" @click="handleFeatureClick('insights')">
                Insights
              </div>
              <b-button
                v-if="false"
                class="upload-btn"
                @click="handleVideoClick(publishing)"
                :disabled="
                  publishing.status !== 'active' ||
                    (!publishing.video && uploadingVideo)
                "
              >
                <span class="content">
                  <span class="ico" v-if="!uploadingVideo && !processingVideo">
                    <svg
                      width="21"
                      height="20"
                      viewBox="0 0 21 20"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <g clip-path="url(#clip0)">
                        <path
                          fill-rule="evenodd"
                          clip-rule="evenodd"
                          d="M20.048 5.09236C20.3255 5.2352 20.5 5.52118 20.5 5.83334V14.1667C20.5 14.4788 20.3255 14.7648 20.048 14.9076C19.7704 15.0505 19.4363 15.0262 19.1823 14.8448L13.349 10.6781C13.13 10.5217 13 10.2691 13 10C13 9.73088 13.13 9.47832 13.349 9.32189L19.1823 5.15523C19.4363 4.97379 19.7704 4.94953 20.048 5.09236ZM15.2671 10L18.8333 12.5473V7.45266L15.2671 10Z"
                          fill="var(--theme-color)"
                        />
                        <path
                          fill-rule="evenodd"
                          clip-rule="evenodd"
                          d="M3 4.99967C2.53976 4.99967 2.16667 5.37277 2.16667 5.83301V14.1663C2.16667 14.6266 2.53976 14.9997 3 14.9997H12.1667C12.6269 14.9997 13 14.6266 13 14.1663V5.83301C13 5.37277 12.6269 4.99967 12.1667 4.99967H3ZM0.5 5.83301C0.5 4.4523 1.61929 3.33301 3 3.33301H12.1667C13.5474 3.33301 14.6667 4.4523 14.6667 5.83301V14.1663C14.6667 15.5471 13.5474 16.6663 12.1667 16.6663H3C1.61929 16.6663 0.5 15.5471 0.5 14.1663V5.83301Z"
                          fill="var(--theme-color)"
                        />
                      </g>
                      <defs>
                        <clipPath id="clip0">
                          <rect
                            width="20"
                            height="20"
                            fill="white"
                            transform="translate(0.5)"
                          />
                        </clipPath>
                      </defs>
                    </svg>
                  </span>
                  <span
                    class="btn-content"
                    v-if="
                      !publishing.video && !uploadingVideo && !processingVideo
                    "
                  >
                    Add Video
                    <input
                      id="blogger-publishing-video"
                      type="file"
                      style="visibility: hidden"
                      @change="uploadBloggerPublishingVideo"
                    />
                  </span>
                  <span
                    class="btn-content"
                    v-if="
                      uploadingVideo &&
                        !publishing.video &&
                        selectedPublishing.id == publishing.id
                    "
                  >
                    <b-spinner small></b-spinner>
                    Uploading {{ progress }}%
                  </span>
                  <span
                    class="btn-content"
                    v-if="
                      processingVideo &&
                        (!publishing.video || !publishing.video.videoThumb) &&
                        selectedPublishing.id == publishing.id
                    "
                  >
                    <b-spinner small></b-spinner>
                    Processing
                  </span>
                  <span
                    class="watch-video"
                    v-if="
                      publishing.video &&
                        publishing.video.videoId &&
                        publishing.video.videoThumb
                    "
                  >
                    Video
                  </span>
                </span>
              </b-button>
              <b-button
                class="btn-simple-primary btn-start"
                @click="handleSubmitPublishingClick(publishing)"
                :disabled="disabledSubmission"
              >
                Submit Publishing
              </b-button>
            </div>
          </div>
        </b-card-body>
      </b-collapse>
    </b-card>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import VideoHandling from "@/mixins/VideoHandling";
import UploadImage from "@/mixins/UploadImage";
import TipTapOutput from "@/components/common/tipTapOutput";
import ImageUpload from "@/components/common/imageUpload";
export default {
  name: "PublishingCard",
  mixins: [UploadImage, VideoHandling],
  components: {
    ImageUpload,
    TipTapOutput
  },
  props: {
    publishing: {
      type: Object,
      default: () => {}
    },
    idx: {
      type: Number,
      default: null
    }
  },
  mounted() {
    this.$root.$on("bv::collapse::state", (collapseId, isJustShown) => {
      if (this.activeCollapse == collapseId) {
        this.activeCollapse = -1;
      }

      if (isJustShown) {
        this.activeCollapse = collapseId;
      }
    });
  },
  computed: {
    ...mapGetters({
      user: "user/user",
      profile: "user/profile",
      listPublishings: "user/listPublishings"
    }),
    disabledSubmission() {
      return false;
      return (
        this.publishing.status == "submitted" ||
        this.publishing.status == "active" ||
        this.publishing.status == "inactive"
      );
    }
  },
  methods: {
    handleImgUploadedURL(idx, url) {
      this.addPublishingCoverImage(idx, url);
    },
    addPublishingCoverImage(idx, url) {
      const updates = { imgURL: url };
      const payload = {
        id: this.publishing.id,
        updates: updates
      };

      this.$store.dispatch("user/updatePublishing", payload).then(res => {
        if (res) {
          this.$bvModal.hide(this.publishingModal);
          this.resetForm();
          this.getPublishings();
          this.$store.dispatch("user/showNotification", {
            title: "Publishings Updated Successfully",
            description: "Awesome",
            variant: "success"
          });
        }
      });
    },
    handleFeatureClick(featureType) {
      this.$emit("feature-click", featureType, this.publishing.id);
    },
    handleToggleForPublishingClick(toggleType, publishing) {
      console.log(
        `In handleToggleForPublishingClick: ${JSON.stringify(publishing)}`
      );
      this.selectedPublishingId = "publishing_1ARXVj72N0dmxAf5PrAu"; //publishing.id;
      this.selectedPublishing = publishing;
      if (this.selectedPublishingId)
        this.$root.$emit("bv::toggle::collapse", toggleType);
    },
    handleRefreshPublishings() {
      console.log("Get Publishings");
      this.getPublishings();
    },
    getPublishings() {
      this.$store
        .dispatch("user/getListPublishings")
        .then(data => {
          console.log(data);
        })
        .catch(error => {
          this.$nprogress.done();
          this.$store.dispatch("user/showNotification", {
            title: error.code,
            description: error.message,
            variant: "danger"
          });
        })
        .finally(() => {
          this.fetching = false;
        });
    },
    handleSelectPublishingForManagement() {
      this.$store
        .dispatch("user/setSelectedPublishingId", this.selectedPublishing.id)
        .then(data => {
          console.log(`Publishing Id submitted`);
          console.log(data);
        })
        .catch(error => {
          this.$nprogress.done();
          this.$store.dispatch("user/showNotification", {
            title: error.code,
            description: error.message,
            variant: "danger"
          });
        })
        .finally(() => {
          this.fetching = false;
        });
    },
    getListedPublishing(event, publishing) {
      //console.log (`Publishing id is ${publishing.id}`);
      // console.log (`Publishinglist  ${this.listPublishings}`);
      //console.log (`Active  ${this.activePublishings}`);

      if (event.target.getAttribute("aria-expanded") == "true") {
        if (publishing.status !== "draft") {
          //this means that it has at east been submitted
          this.activePublishings = [];
          let existingPublishing = this.listPublishings.filter(
            lPublishing => lPublishing.id === publishing.id
          );
          if (existingPublishing.length == 0) {
            this.$store
              .dispatch("listings/getListPublishingById", publishing.id)
              .then(data => {
                this.activePublishings = data; //TODO Decide wehre to keep this publishing
                console.log("thisPublishing => ", this.activePublishings);
              })
              .catch(error => {
                console.log("Error getting document: ", error);
              });
          } else {
            this.activePublishings = existingPublishing[0];
          }
        }
      } else return;
    },
    handleSubmitPublishingClick(publishing) {
      let publishingType = "author";

      let owner =
        publishingType === "author"
          ? {
              firstname: this.profile.firstname ? this.profile.firstname : null,
              lastname: this.profile.lastname ? this.profile.lastname : null,
              imgURL: this.profile.imgURL ? this.profile.imgURL : null,
              profileName: this.profile._dashboards.guide.profileName
                ? this.profile._dashboards.guide.profileName
                : null, //will be global
              userId: this.profile.userId ? this.profile.userId : null
            }
          : {
              firstname: this.profile.firstname ? this.profile.firstname : null,
              lastname: this.profile.lastname ? this.profile.lastname : null,
              imgURL: this.profile.imgURL ? this.profile.imgURL : null,
              profileName: this.profile._dashboards.guide.profileName
                ? this.profile._dashboards.guide.profileName
                : null,
              userId: this.profile.userId ? this.profile.userId : null
            };

      this.$store
        .dispatch("listings/submitPublishing", { publishing, owner })
        .then(res => {
          if (res) {
            this.$store
              .dispatch("user/submitPublishing", publishing)
              .then(res => {
                this.getPublishings();
                this.$store.dispatch("user/showNotification", {
                  title: "Publishing Submitted Successfully",
                  description:
                    "Your publishing has now been submitted for Review",
                  variant: "success"
                });
              });
          }
        });
    },
    updatePublishing(publishing) {
      const payload = {
        id: this.publishings[this.activeIndex].id,
        updates: publishing
      };

      this.$store.dispatch("user/updatePublishing", payload).then(res => {
        if (res) {
          this.$bvModal.hide(this.publishingModal);
          this.resetForm();
          this.getPublishings();
          this.$store.dispatch("user/showNotification", {
            title: "Publishings Updated Successfully",
            description: "Awesome",
            variant: "success"
          });
        }
      });
    },
    handleDeletePublishing() {
      this.$emit("delete-publishing", this.publishing);
    },
    deletePublishing() {
      let publishing = this.publishings[this.activeIndex];
      this.$store.dispatch("user/deletePublishing", publishing).then(res => {
        if (res) {
          this.$bvModal.hide(this.publishingModal);
          this.getPublishings();
          this.del = false;
          this.$store.dispatch("user/showNotification", {
            title: "Publishings Updated Successfully",
            description: "Awesome",
            variant: "success"
          });
        }
      });
    },
    handleEditPublishing() {
      console.log("go edit");
      this.$emit("edit-publishing", this.publishing);
    },
    addPublishing() {
      let publishing = {
        id: `pub_${this.generatePublishingId(20)}`,
        _created_at: new Date(),
        status: "draft",
        title: this.publishing.title
      };
      if (this.publishing.subtitle)
        publishing.subtitle = this.publishing.subtitle;
      if (this.publishing.description)
        publishing.description = this.publishing.description;
      if (this.publishing.language)
        publishing.language = this.publishing.language;
      if (this.publishing.subtitle)
        publishing.publisher = this.publishing.publisher;
      if (this.publishing.isbn) publishing.isbn = this.publishing.isbn;
      if (this.publishing.author) publishing.author = this.publishing.author;
      if (this.publishing.illustrator)
        publishing.illustrator = this.publishing.illustrator;
      if (this.publishing.editor) publishing.editor = this.publishing.editor;
      if (this.publishing.pages) publishing.pages = this.publishing.pages;
      if (this.publishing.reviews) publishing.reviews = this.publishing.reviews;
      if (this.publishing.price) publishing.price = this.publishing.price;
      if (this.publishing.tools) publishing.tools = this.publishing.tools;
      //------
      if (this.publishing.series) publishing.series = this.publishing.series;
      if (this.publishing.category)
        publishing.category = this.publishing.category;
      if (this.publishing.copyright)
        publishing.copyright = this.publishing.copyright;

      //Authors, Illustrators, etc
      if (this.publishing.crew) publishing.crew = this.publishing.crew;

      /*
        series: this.publishing.series,
        publishingRights:this.publishing.publishingRights ? this.publishing.publishingRights : '',
        keywords: this.publishing.keywords,
        adultContent: this.publishing.adultContent ? this.publishing.adultContent : '',
        spheres: this.publishing.spheres,
        seo: this.publishing.seo,
        guides: this.publishing.guides,
        connections: this.publishing.connections,
        engines: this.publishing.engines,
        weeks: this.publishing.weeks,
        roles: this.publishing.roles,
        categories: this.publishing.categories,
        languages: this.publishing.languages,
        age: this.publishing.age,
        leaningStyle: this.publishing.leaningStyle,
        copyright: this.publishing.copyright,
        imgURL: "",
      };*/
      this.$store.dispatch("user/addPublishing", publishing).then(res => {
        if (res) {
          this.$bvModal.hide(this.publishingModal);
          this.resetForm();
          this.getPublishings();
          this.$store.dispatch("user/showNotification", {
            title: "Publishings Added Successfully",
            description: "The Publishing has been addeded",
            variant: "success"
          });
        }
      });
    },
    hideDeletePublishing() {
      this.$bvModal.hide(this.publishingModal);
    },
    resetClear() {
      this.clear = false;
    },
    input(val) {
      this.publishing.description = val.content;
    },
    getThumbnail(publishing) {
      if (publishing.video && !publishing.video.videoThumb) {
        this.selectedPublishing = publishing;
        this.processingVideo = true;
        this.getVideoThumbnail(publishing.video.videoId).then(thumbnail => {
          this.$store
            .dispatch("user/updatePublishingVideoThumbnail", {
              id: publishing.id,
              thumbnail
            })
            .then(res => {
              this.$store.dispatch("user/getListPublishings").then(data => {
                this.processingVideo = false;
              });
            });
        });
      }
    },
    getStatus(status) {
      switch (status) {
        case "draft":
          return "Draft";
        case "submitted":
          return "Submitted";
        case "need_work":
          return "Needs Work";
        case "inactive":
          return "Removed";
        case "active":
          return "Published";
        default:
          return "Draft";
      }
    },
    getStatusColor(status) {
      switch (status) {
        case "draft":
          return "#C0C0C0";
        case "submitted":
          return "#557efb";
        case "need_work":
          return "#FFCC00";
        case "inactive":
          return "#FF0000";
        case "active":
          return "#4BB543";
        default:
          return "#C0C0C0";
      }
    },
    addTag() {
      if (this.seo.trim() == "") return;
      this.publishing.seo.unshift(this.seo);
      this.seo = "";
    },
    delTag(tag) {
      let index = this.publishing.seo.indexOf(tag);
      if (index > -1) {
        this.publishing.seo.splice(index, 1);
      }
    },
    cancelAction() {
      this.resetForm();
      this.$bvModal.hide(this.publishingModal);
      this.refresh++;
    },
    generatePublishingId(length) {
      //move to mixin
      var result = "";
      var characters =
        "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
      var charactersLength = characters.length;
      for (var i = 0; i < length; i++) {
        result += characters.charAt(
          Math.floor(Math.random() * charactersLength)
        );
      }
      const date = new Date().valueOf();
      return `${this.user.uid}_${result}_${date}`;
    },
    resetForm() {
      this.publishing = {
        title: "",
        subtitle: "",
        description: "",
        seo: [],
        spheres: [],
        tools: [],
        guides: [],
        connections: [],
        engines: [],
        imgURL: "",
        roles: null,
        weeks: 0,
        price: 0,
        categories: "",
        languages: [],
        age: 3,
        leaningStyle: "",
        copyright: ""
      };
      this.seo = "";
      this.activeIndex = null;
      this.activePublishingStatus = null;
      this.trackContent = {};
    },
    handleVideoClick(publishing) {
      if (!publishing.video) {
        this.selectedPublishing = publishing;
        this.triggerChooseVideo();
      } else {
        console.log("yes");
        this.activeVideo = publishing.video;
        this.$bvModal.show(this.authorPublishingVideo);
      }
    },
    triggerChooseVideo() {
      document.getElementById("blogger-publishing-video").click();
    },
    uploadBloggerPublishingVideo(event) {
      let file = event.target.files[0];
      let name = `activation_track_${this.profile.userId}_${(Date.now() /
        1000) |
        0}`;
      let description = `${this.profile.firstname}'s activation Publishing Video.`;
      this.uploadVideo(file, name, description).then(video => {
        this.saveVideo(video);
      });
    },
    saveVideo({ videoName, vimeoURL, videoId, vimeoName }) {
      this.processingVideo = true;
      let data = {
        id: this.selectedPublishing.id,
        video: {
          _created_at: new Date(),
          videoName,
          vimeoURL,
          videoId,
          vimeoName
        }
      };
      this.$store
        .dispatch("user/addPublishingVideo", data)
        .then(res => {
          this.selectedPublishing.video = data.video;
          this.getVideoThumbnail(videoId).then(thumbnail => {
            this.$store
              .dispatch("user/updatePublishingVideoThumbnail", {
                id: data.id,
                thumbnail
              })
              .then(res => {
                this.selectedPublishing.video.videoThumb = thumbnail;
                this.processingVideo = false;
                this.$store.dispatch("user/showNotification", {
                  title: "Video Added",
                  description: "Your video has been successfully added.",
                  variant: "success"
                });
              });
          });
        })
        .catch(e => {
          this.processingVideo = false;
          this.getPublishings();
          console.log(e);
        });
    },
    trimStr(str, len) {
      if (str.length <= len) return str;
      else return str.substr(0, len) + "...";
    }
  },
  data() {
    return {
      mainProps: { blank: false, blankColor: '#777', width: 75, height: 75, class: 'm1' },
      mainPropsBlank: { blank: true, blankColor: '#777', width: 75, height: 75, class: 'm1' },
      storagePath: "rb_shop_product_img",
      showingMore: false,
      selectedPublishing: {},
      selectedPublishingId: null,
      fetching: false,
      publishingModal: "publishing-modal",
      authorPublishingVideo: "author-publishing-video",
      refresh: 1,
      showCard: false,
      add: true,
      del: false,
      activeIndex: -1,
      activeCollapse: -1,
      isJustShown: false,
      searchStr: "",
      clear: false,
      trackContent: {},
      seo: "",
      asset: "",
      popupText: "Copy to clipboard",
      uploadingImage: false,
      activeImage: "",
      imgDataUrl: "",
      imgURL: "",
      trackPassing: {},
      rolesArray: [],
      languagesArray: [],
      activeVideo: null,
      processingVideo: false,
      activePublishingStatus: null,
      activePublishing: null,
      engines: [],
      addedEngines: [],
      oldEngines: [],
      showEngine: false,
      showUpload: false,
      uploadingScreen: false,
      currIndex: "",
      params: {
        token: "123456798",
        name: "avatar"
      },
      headers: {
        smail: "*_~"
      },
      cornerId: `corner`,
      qrId: `qr`,
      insightsId: `insights`
    };
  }
};
</script>

<style lang="scss" scoped>
.publishing-foot {
  display: flex;
  justify-content: space-between;
  .stats {
    display: flex;
    align-items: center;
    .ico {
      margin: 0 17px;
    }
  }
  .collapse-foot {
    display: flex;
    justify-content: flex-end;
    .btn-simple-primary {
      background-color: #fff;
      font-style: normal;
      font-weight: 600;
      font-size: 14px;
      line-height: 19px;
      justify-content: center;
      padding: 8px 16px;
      border: none;
      display: flex;
      letter-spacing: 0.05em;
      align-items: center;
      color: var(--theme-color);
      margin-left: 16px;
      border-radius: 4px;
      transition: all 0.2s ease-in-out;
      svg {
        margin-right: 16px;
      }
      &:hover {
        background-color: #f3f6f9;
      }
      &.btn-start {
        background-color: #f3f6f9;
        &:hover {
          background-color: #dfdfdf;
          box-shadow: 0px 0px 4px 0px #eee;
        }
      }
    }
  }
}

.areas {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  margin-left: 25%;
  & > div {
    width: 60px;
    h6 {
      font-style: normal;
      font-weight: normal;
      font-size: 12px;
      line-height: 16px;
      color: #8d99a0;
    }
    svg {
      cursor: pointer;
    }
  }
}
.small-check {
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 19px;
  color: #8d99a0;
  margin-left: 24px;
}
.custom-control-label {
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 22px;
  color: #474d52;
}
.bv-no-focus-ring {
  position: relative;
  .pre {
    position: absolute;
    left: 15px;
    top: 50%;
    transform: translateY(-50%);
    color: #8d99a0;
  }
  .post {
    position: absolute;
    right: 15px;
    top: 50%;
    color: #8d99a0;
    transform: translateY(-50%);
  }
  input {
    padding-left: 30px;
  }
}
.add-publishings {
  font-style: normal;
  font-weight: bold;
  font-size: 14px;
  line-height: 19px;
  color: var(--theme-color);
  cursor: pointer;
  position: relative;
}
.add-publishing {
  .foot {
    margin-top: 24px;
    border-top: 1px solid #dddddd;
    padding: 24px 0 10px 0;
  }
  .close-icon {
    position: absolute;
    top: 24px;
    right: 20px;
    cursor: pointer;
  }
  .btn-round-fill {
    max-width: 160px;
    width: 100%;
  }
  h3 {
    margin-bottom: 0;
    margin-top: 10px;
    font-style: normal;
    font-weight: 600;
    font-size: 24px;
    line-height: 33px;
    color: #474d52;
    text-align: center;
  }
}
.del-publishing {
  .warning-msg {
    margin: 24px 0;
    p {
      text-align: center;
      margin: 0;
    }
  }
  .btn-round-fill {
    background-color: #ef5c4a;
    border-color: #ef5c4a;
  }
  .btn-simple {
    color: #ef5c4a;
    font-weight: bold;
  }
}

.search {
  cursor: pointer;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 19px;
  color: #8d99a0;
}
.card-guide {
  box-shadow: none;
}
.publishings {
  margin-top: 20px;
  .card {
    border: none;
    box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.08);
    .details {
      display: flex;
      align-items: center;
      margin-bottom: 10px;
      & > div {
        margin-right: 18px;
        display: flex;
        align-items: center;
        svg {
          margin-right: 5px;
        }
      }
      .ico {
        margin: 0 17px;
        cursor: pointer;
      }
      .doc-ico {
        margin-left: 0;
      }
      .doc-link {
        color: var(--theme-color);
      }
    }
    .card-text {
      font-style: normal;
      font-weight: normal;
      font-size: 14px;
      line-height: 19px;
      display: flex;
      align-items: center;
      color: #474d52;
    }
    .status-btn {
      display: inline-block;
      margin-right: 15px;
      width: 105px;
      height: 21px;
      font-family: Nunito;
      font-style: normal;
      font-weight: normal;
      font-size: 14px;
      color: #ffffff;
      background: var(--theme-color);
      text-align: center;
      border: none;
      border-radius: 3px;
    }
  }

  .card-header {
    display: grid;
    grid-template-columns: 1fr 30px;
    align-items: center;
    padding: 0;
    .edit,
    .delete {
      display: none;
      cursor: pointer;
    }
    .btn-collapse {
      padding: 24px;
      text-align: left;
      box-shadow: none;
    }
    &.active {
      grid-template-columns: 1fr 30px 30px 30px;
      .edit,
      .delete {
        display: block;
      }
    }

    border: none;
    box-shadow: none;
    background: none;
  }
  .card-body {
    padding-top: 0;
    img {
      cursor: pointer;
      position: relative;
      // top: 50%;
      right: 4px;
      // -webkit-transform: translateY(-50%);
      // transform: translateY(-50%);
      height: 100px;
      width: 100px;
      display: -webkit-box;
      display: -ms-flexbox;
      display: flex;
      -webkit-box-align: center;
      -ms-flex-align: center;
      align-items: center;
      -webkit-box-pack: center;
      -ms-flex-pack: center;
      justify-content: center;
      background: rgba(85, 126, 251, 0.1);
      border-radius: 8px;
    }
    .publishing-description {
      left: 5px;
    }
  }
}
.places-lived {
  margin-top: 26px;
  .place__places-lived {
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 19px;
    color: #474d52;
    margin: 6px 15px;
  }
  .del__ico {
    cursor: pointer;
  }
}
.submit-btn {
  border-radius: 28px;
  width: 120px;
}
.roles {
  margin-top: 25px;
}
.tools {
  margin-top: 32px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border: 1px solid #eceff9;
  border-radius: 8px;
  padding: 12px 20px;
  position: relative;
  .extra-tools {
    position: absolute;
    top: 100%;
    width: 100%;
    left: 0;
    background-color: #fff;
    border: 1px solid #eceff9;
    border-top: 0;
    padding: 0px 11px 11px 11px;
    display: flex;
    justify-content: center;
  }
  .ico {
    cursor: pointer;
  }
  .ico,
  img {
    margin: 0 17px;
  }
  & > div {
    flex-wrap: wrap;
    display: flex;
    align-items: center;
    h6 {
      font-style: normal;
      font-weight: normal;
      font-size: 24px;
      line-height: 33px;
      color: #5b606c;
      margin: 0 10px 0 0;
    }
  }
  .engine {
    margin-top: 3px;
    background-color: rgba(85, 126, 251, 0.1);
    border-radius: 5px;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 5px;
    font-family: "Nunito", sans-serif;
    font-style: normal;
    font-weight: 600;
    font-size: 16px;
    line-height: 22px;
    display: flex;
    align-items: center;
    color: var(--theme-color);
    margin-right: 7px;
    svg {
      margin-left: 5px;
      cursor: pointer;
    }
  }

  h6 {
    font-style: normal;
    font-weight: normal;
    font-size: 24px;
    line-height: 33px;
    display: inline;
    color: #5b606c;
    margin-right: 10px;
    //   margin-bottom: 0;
  }
}
.crew {
  margin-top: 32px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border: 1px solid #eceff9;
  border-radius: 8px;
  padding: 12px 20px;
  position: relative;
  .extra-crew {
    position: absolute;
    top: 100%;
    width: 100%;
    left: 0;
    background-color: #fff;
    border: 1px solid #eceff9;
    border-top: 0;
    padding: 0px 11px 11px 11px;
    display: flex;
    justify-content: center;
  }
  .ico {
    cursor: pointer;
  }
  .ico,
  img {
    margin: 0 17px;
  }
  & > div {
    flex-wrap: wrap;
    display: flex;
    align-items: center;
    h6 {
      font-style: normal;
      font-weight: normal;
      font-size: 24px;
      line-height: 33px;
      color: #5b606c;
      margin: 0 10px 0 0;
    }
  }
  .engine {
    margin-top: 3px;
    background-color: rgba(85, 126, 251, 0.1);
    border-radius: 5px;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 5px;
    font-family: "Nunito", sans-serif;
    font-style: normal;
    font-weight: 600;
    font-size: 16px;
    line-height: 22px;
    display: flex;
    align-items: center;
    color: var(--theme-color);
    margin-right: 7px;
    svg {
      margin-left: 5px;
      cursor: pointer;
    }
  }

  h6 {
    font-style: normal;
    font-weight: normal;
    font-size: 24px;
    line-height: 33px;
    display: inline;
    color: #5b606c;
    margin-right: 10px;
    //   margin-bottom: 0;
  }
}
.video-sec {
  margin-left: 15px;
}
.upload-btn {
  cursor: pointer;
  background-color: #fff;
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  line-height: 19px;
  max-width: 220px;
  height: 50px;
  border: none;
  letter-spacing: 0.05em;
  align-items: center;
  color: var(--theme-color);
  margin-left: 16px;
  border-radius: 4px;
  transition: all 0.2s ease-in-out;
  display: flex;
  justify-content: center;
  align-items: center;
  .content {
    display: flex;
    #blogger-publishing-video {
      width: 0;
    }
    #guide-publishing-image {
      width: 0;
    }
    .ico {
      margin-right: 3px;
      img {
        cursor: pointer;
        position: relative;
        top: 50%;
        right: 4px;
        -webkit-transform: translateY(-50%);
        transform: translateY(-50%);
        height: 24px;
        width: 24px;
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-align: center;
        -ms-flex-align: center;
        align-items: center;
        -webkit-box-pack: center;
        -ms-flex-pack: center;
        justify-content: center;
        background: rgba(85, 126, 251, 0.1);
        border-radius: 8px;
      }
      svg {
        height: 30px;
      }
    }
    .watch-video {
      margin-top: 5px;
    }
    .btn-content {
      margin-top: 2px;
      font-family: Nunito;
      font-style: normal;
      font-size: 16px;
      line-height: 22px;
      color: var(--theme-color);
    }
  }
}
.upload-btn:focus {
  outline: none;
  box-shadow: none;
}
.description-title {
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 19px;
  color: #8d99a0;
  max-width: 354px;
  width: 100%;
  margin: 18px 0;
  cursor: pointer;
}
.half-fields {
  margin-left: 3px;
}
.fadeHeight-enter-active,
.fadeHeight-leave-active {
  transition: all 0.5s;
  max-height: 230px;
}
.fadeHeight-enter,
.fadeHeight-leave-to {
  opacity: 0;
  max-height: 0px;
  overflow: hidden;
}
</style>
